//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import * as yup from 'yup'
import { erc20WeiToCommaDecString } from './conversions'
import { FieldMetaData, StringTypeEnum, toFieldMetaData } from './SchemaTypes'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertYupSchemaValuesToDecStr = (schema: any): any => {
  const ret: Record<string, yup.StringSchema<string | undefined, yup.AnyObject, undefined, ''>> = {}
  for (const fs in schema.describe().fields) {
    const fieldSchema = schema.describe().fields[fs] as yup.SchemaDescription
    //    const fieldSchema = schema.describe().fields[propName] as yup.SchemaDescription

    const fieldMetaData = fieldSchema.meta as FieldMetaData
    const propName = fieldMetaData.propName

    const label = fieldSchema.label as string
    if (
      fieldMetaData.stringType === StringTypeEnum.STABLE_COINS ||
      fieldMetaData.stringType === StringTypeEnum.PPT_SHARES
    ) {
      const decStrKey = `${propName}DecStr`
      const decStrYupValue = yup
        .string()
        .label(label)
        .meta(toFieldMetaData({ propName: decStrKey, stringType: StringTypeEnum.DECIMAL_STRING }))

      ret[decStrKey] = decStrYupValue
    }
  }
  return ret
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertValuesToDecStr = (schema: any, dataObject: Record<string, any>): Record<string, string> => {
  const ret: Record<string, string> = {}
  for (const fs in schema.describe().fields) {
    const fieldSchema = schema.describe().fields[fs] as yup.SchemaDescription
    //    const fieldSchema = schema.describe().fields[propName] as yup.SchemaDescription

    const fieldMetaData = fieldSchema.meta as FieldMetaData

    const propName = fieldMetaData.propName

    if (
      fieldMetaData.stringType === StringTypeEnum.STABLE_COINS ||
      fieldMetaData.stringType === StringTypeEnum.PPT_SHARES
    ) {
      const decStrKey = `${propName}DecStr`
      const originalValue = dataObject[propName]
      const decStrValue = erc20WeiToCommaDecString(originalValue)

      ret[decStrKey] = decStrValue
    }
  }
  return ret
}
